import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Heart, Bell, BellRing } from 'lucide-react';

const MOOD_OPTIONS = [
  {
    emoji: '😞',
    label: 'Not great',
    key: 'not-great',
    persona: 'Mom',
    placeholder: "Take your time. What's weighing on you today, sweetheart?",
  },
  {
    emoji: '😐',
    label: 'Mixed',
    key: 'mixed',
    persona: 'Listener',
    placeholder: "I'm here. No rush — what's on your mind?",
  },
  {
    emoji: '🙂',
    label: "I'm okay",
    key: 'okay',
    persona: 'Best Friend',
    placeholder: "Glad you stopped by. What's going on with you?",
  },
];

const GraceCheckIn = ({ onMoodSelect, onDismiss, onEnableReminders, remindersEnabled }) => {
  return (
    <Card
      className="card-surface border-[#8B5CF6]/40 bg-gradient-to-br from-[#1a0f2e] to-[#0A0A0A] mb-8"
      data-testid="grace-checkin-card"
    >
      <CardContent className="p-6 sm:p-8 text-center space-y-5">
        <div className="flex items-center justify-center gap-2 text-[#D4AF37]">
          <Heart className="w-4 h-4 fill-[#D4AF37]" />
          <span className="text-xs uppercase tracking-[0.3em] font-semibold">Grace Check-In</span>
          <Heart className="w-4 h-4 fill-[#D4AF37]" />
        </div>
        <h2
          className="text-2xl sm:text-3xl font-light text-[#F9FAFB]"
          style={{ fontFamily: 'Outfit' }}
          data-testid="grace-checkin-headline"
        >
          It's okay to not be okay today.
        </h2>
        <p className="text-[#A1A1AA]">How are you, really?</p>

        <div className="grid grid-cols-3 gap-3 max-w-md mx-auto pt-2">
          {MOOD_OPTIONS.map((mood) => (
            <button
              key={mood.key}
              type="button"
              onClick={() => onMoodSelect(mood)}
              data-testid={`grace-mood-${mood.key}`}
              className="group flex flex-col items-center gap-2 px-3 py-4 rounded-2xl border border-[#27272A] bg-[#0A0A0A] hover:border-[#8B5CF6] hover:bg-[#8B5CF6]/10 transition-all"
            >
              <span className="text-3xl group-hover:scale-110 transition-transform">
                {mood.emoji}
              </span>
              <span className="text-xs sm:text-sm text-[#A1A1AA] group-hover:text-[#F9FAFB]">
                {mood.label}
              </span>
            </button>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row gap-2 items-center justify-center pt-3">
          <Button
            type="button"
            variant="ghost"
            size="sm"
            onClick={onEnableReminders}
            className="text-[#D4AF37] hover:text-[#F9FAFB] hover:bg-[#D4AF37]/10 gap-2 text-xs"
            data-testid="grace-enable-reminders"
          >
            {remindersEnabled ? <BellRing className="w-3.5 h-3.5" /> : <Bell className="w-3.5 h-3.5" />}
            {remindersEnabled ? 'Daily reminders on' : 'Remind me daily'}
          </Button>
          <button
            type="button"
            onClick={onDismiss}
            className="text-[#71717A] hover:text-[#A1A1AA] text-xs px-3 py-1"
            data-testid="grace-dismiss"
          >
            Not today
          </button>
        </div>
      </CardContent>
    </Card>
  );
};

export default GraceCheckIn;
